import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const whatsappChannel = defineChannel({
  id: 'whatsapp',
  icon: 'brand/whatsapp',
  name: 'WhatsApp',
  shortName: 'WhatsApp',
  noun: 'WhatsApp message',
  events: ['attempted', 'sent', 'delivered', 'failed', 'opened', 'converted', 'replied'],
  deliveryStates: ['attempted', 'sent', 'failed', 'holdout', 'delivered'],
  deliveryActions: ['clicked', 'opened', 'converted'],
} as const satisfies ChannelDefinition);
